import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./routes/AppRoutes";
import { KycProvider } from "./context/KycContext";

export default function App() {
  return (
    <KycProvider>
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
    </KycProvider>
  );
}
